import { IChatV2Schema } from '@cian/chats-api';

// eslint-disable-next-line import/no-cycle
import { openEventChannel } from './openEventChannel';
import { CHATBOT_ID } from '../../../constants/chatbotId';
import { EMessageType, TMessageSchema } from '../../../types/messages';
import { ETelemetryEvents } from '../../../types/telemetry';
import { handleRawMessageForNotification } from '../../../utils/messageUtils';
import { mapChatV2VersionToV1 } from '../../../utils/v2ToV1/mapChat';
import { checkUsersSession } from '../../services/checkUsersSession';
import { addChat } from '../../slices/chatList';
import { addMessageInQueue, editMessageInQueue } from '../../slices/messagesQueue';
import { TThunkAction } from '../../types/redux/thunk';
import { ERequestApiStatus } from '../../types/widgetState';
import { checkNotifications } from '../notifications/checkNotifications';

export const listenEventChannel =
  (): TThunkAction<void> =>
  (dispatch, getState, { logger, telemetry, custom: { messagesMap, socket } }) => {
    if (!socket) {
      return;
    }

    const { clientEvents, eventChannel } = socket;

    const onMessageId = eventChannel.addIncommingMessageListener(({ data }) => {
      const state = getState();

      const {
        chatList,
        user: { userId },
      } = state;

      switch (data.type) {
        case 'session':
          if (data.uid) {
            const clientEvent = clientEvents.get(data.uid);

            if (!clientEvent) {
              return;
            }

            clientEvents.set(data.uid, { ...clientEvent, status: ERequestApiStatus.Succeed });
          }
          if (data.session.expired) {
            dispatch(checkUsersSession());
          }
          telemetry.increment(ETelemetryEvents.ChatWsSessionSuccess);

          break;
        case 'chat':
          const chat = data.chat as unknown as IChatV2Schema;

          const incomingChat = mapChatV2VersionToV1(chat);
          dispatch(addChat(incomingChat));

          dispatch(checkNotifications());

          break;
        case 'message':
          const { message } = data;

          const { parsedMessage, isExists } = handleRawMessageForNotification(
            message as unknown as TMessageSchema,
            messagesMap,
            userId,
          );
          const messageChat = chatList.find(c => c.chatId === parsedMessage.chatId);

          if (
            (messageChat && messageChat.type === 'bot') ||
            parsedMessage.chatId === CHATBOT_ID ||
            parsedMessage.message.isOutcoming ||
            parsedMessage.message.userId === userId ||
            parsedMessage.message.type === EMessageType.LeadInfo ||
            parsedMessage.message.type === EMessageType.SystemInfo
          ) {
            return;
          }

          if (!isExists && !parsedMessage.message.isRead) {
            dispatch(addMessageInQueue({ parsedMessage, messagesMap }));
          } else if (isExists && parsedMessage.message.isRead) {
            dispatch(editMessageInQueue({ messageId: message.messageId, isShow: true }));
          }

          dispatch(checkNotifications());

          break;
      }
    });

    const onCloseId = eventChannel.addEventChannelListener('close', () => {
      eventChannel.removeIncommingMessageListener(onMessageId as string);
      eventChannel.removeEventChannelListener('close', onCloseId);

      telemetry.increment(ETelemetryEvents.ChatWsSocketClose);
      logger.warning('WS соединение закрыто', {
        domain: 'src/shared/services/chatbotFeedback/fetchOfferView/fetchOfferView.ts',
      });

      if (document.visibilityState !== 'hidden') {
        dispatch(openEventChannel());
      }
    });
  };

export const closeEventChannel =
  (): TThunkAction<void> =>
  (dispatch, getState, { custom: { socket } }) => {
    if (!socket) {
      return;
    }

    const { eventChannel } = socket;

    eventChannel.closeEventChannel();
  };
